var _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.988 34.836C25.092 34.836 27.516 32.364 27.516 29.46C27.516 26.892 26.1 25.524 23.94 24.636L21.612 23.652C20.1 23.052 18.828 22.596 18.828 21.324C18.828 20.148 19.836 19.452 21.396 19.452C22.86 19.452 24.036 19.98 25.164 20.916L26.964 18.684C25.524 17.22 23.46 16.404 21.396 16.404C17.796 16.404 15.252 18.636 15.252 21.54C15.252 24.132 17.052 25.572 18.852 26.316L21.228 27.324C22.812 27.996 23.892 28.404 23.892 29.724C23.892 30.972 22.908 31.764 21.06 31.764C19.5 31.764 17.82 30.972 16.548 29.796L14.508 32.244C16.236 33.9 18.612 34.836 20.988 34.836ZM30.6606 34.5H34.2126V16.74H30.6606V34.5Z",
    fill: "url(#paint0_linear_596_8642)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "url(#paint1_linear_596_8642)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_596_8642",
    x1: 36.5,
    y1: 34.5,
    x2: 11.7356,
    y2: 31.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F89CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3F9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_596_8642",
    x1: 50,
    y1: 50.5,
    x2: -4.11793,
    y2: 45.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F89CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3F9C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSi);
export default __webpack_public_path__ + "static/media/icon-si.b5c4d1191b6ff7f4702dd1d58d54e3f3.svg";
export { ForwardRef as ReactComponent };